import styled from "styled-components";

import bg from "./signin-with-google.png";

export const LoginWithGoogleButton = styled.button`
  display: block;
  width: 208px;
  height: 50px;
  border: none;
  padding: 0;
  background: url(${bg}) center center no-repeat;
  background-size: contain;

  &:disabled {
    filter: grayscale();
    opacity: 0.5;
    background: url(${bg}) center center no-repeat !important;
    background-size: contain !important;
  }
`;
